import { render, staticRenderFns } from "./list.vue?vue&type=template&id=450bf4a1&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450bf4a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('450bf4a1')) {
      api.createRecord('450bf4a1', component.options)
    } else {
      api.reload('450bf4a1', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=450bf4a1&scoped=true", function () {
      api.rerender('450bf4a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/list.vue"
export default component.exports